import { Loading } from '@/components/Loading';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

interface InfiniteScrollListProps {
  children: ReactNode;
  dataLength: number;
  next: () => void;
  hasMore: boolean;
  total?: number;
  scrollableTarget?: string;
}

export const InfiniteScrollList = ({
  children,
  dataLength,
  next,
  hasMore,
  total,
  scrollableTarget,
}: InfiniteScrollListProps) => {
  const { t } = useTranslation();

  return (
    <InfiniteScroll
      dataLength={dataLength}
      next={next}
      hasMore={hasMore}
      loader={<Loading />}
      scrollableTarget={scrollableTarget}
      endMessage={
        <p className="py-4 text-center text-gray-light">
          {t('infiniteScroll:allLoaded', { total: total || dataLength })}
        </p>
      }
    >
      {children}
    </InfiniteScroll>
  );
};
